import { siteContent } from "../../content/siteContent";

export function Qualifications() {
  const { qualifications } = siteContent;

  return (
    <section
      className="home-qualifications home-section"
      aria-labelledby="home-qualifications-title"
    >
      <div className="home-shell home-qualifications__layout">
        <div>
          <p className="home-eyebrow">{qualifications.eyebrow}</p>
          <h2 id="home-qualifications-title">{qualifications.title}</h2>
        </div>

        <ol className="home-qualifications__list">
          {qualifications.items.map((item, index) => (
            <li key={item}>
              <span aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p>{item}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
